<div class="full-page-container">
  <ng-container *notInProductCode="productCode.Partners">
    <div class="banner d-none d-lg-flex" role="banner">
      <div class="container">
        <h5 class="text-white text-start mb-0">{{ 'games.page.title' | translate }}</h5>
      </div>
    </div>

    <fgb-page-header [pageTitle]="'games.play.title'" [backButtonLink]="'/'"></fgb-page-header>

    <div class="mobile-content-wrapper">
      <div class="container">
        <div class="card border">
          <img [alt]="'games.page.trivia.title' | translate" src="assets/images/games/trivia.jpg" />
          <div class="card-body">
            <div class="upper-card-body">
              <h3>{{ 'games.page.trivia.title' | translate }}</h3>
              <p>{{ 'games.page.trivia.description' | translate }}</p>
            </div>
            <a class="btn btn-secondary" [routerLink]="['/games/trivia']">{{ 'games.page.trivia.button' | translate }}</a>
          </div>
        </div>
        <div class="card border">
          <img [alt]="'games.page.polls.title' | translate" src="assets/images/games/polls.jpg" />
          <div class="card-body">
            <div class="upper-card-body">
              <h3>{{ 'games.page.polls.title' | translate }}</h3>
              <p>{{ 'games.page.polls.description' | translate }}</p>
            </div>
            <a class="btn btn-secondary" [routerLink]="['/games/polls']">{{ 'games.page.polls.button' | translate }}</a>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *inProductCode="productCode.Partners">
    <fgb-not-found-page></fgb-not-found-page>
  </ng-container>
</div>
